export const STATES = [
    "PENDIENTE",
    "ENPROCESO",
    "FINALIZADA"
];

export const ORIGENES = [
    "DIRECTO",
    "CALCULO",
    "CHECKLIST"
]

export const ALERTSProcedimientosProgramados = [
    'VENC',
    'PorVENC'
]

export const STATESProcsProgramados = [
    'PEND',
    'PROG',
    'COMPL'
]

export const CHECKLISTStates = [
    'CTRLFALLIDOS', 'CTRLEXITOSOS'
]

export const TIPPROCS = [
    'CORRECTIVO', 'PREVENTIVO','PREDICTIVO','MEJORA','PREVENTIVONOPeriod'
]

export const ACTIVOSTATES = ['DISPO','FSERV'];

export const CRITICIDAD = ['BAJA','MEDIA','ALTA'];

export const ifState = (state,user = null) => {
    switch (state) {
        case "PENDIENTE":
            return (user != null && user.userType[0].typeName == "ADMIN") ? ["ENPROCESO", "FINALIZADA"] : ["ENPROCESO"];
        case "ENPROCESO":
            return ['FINALIZADA'];
        default: return [];
    }
}